import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="impact-banner" aria-labelledby="impact-heading">
      <div className="impact-wrap">
        <motion.div
          className="impact-left"
          initial={{ opacity: 0, x: -24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="impact-eyebrow">Platform-friendly marketing</p>
          <h2 id="impact-heading" className="impact-title">
            Landing pages that match your ads
          </h2>
          <p className="impact-sub">
            Clear business identity, honest offers, and easy paths to privacy terms and contact details—common
            expectations when running Google Ads and similar programs.
          </p>
          <ul className="impact-trust">
            <li>No hidden fees buried in ad copy</li>
            <li>Disclosures for endorsements &amp; affiliates</li>
            <li>Cookies and analytics described in your privacy policy</li>
            <li>HTTPS and working contact methods</li>
          </ul>
          <div className="impact-actions">
            <button type="button" className="impact-btn primary" onClick={() => navigate("/privacy-policy")}>
              Privacy policy <span aria-hidden="true">→</span>
            </button>
            <button type="button" className="impact-btn secondary" onClick={() => navigate("/disclaimer")}>
              Disclaimer
            </button>
          </div>
        </motion.div>

        <motion.div
          className="impact-right"
          initial={{ opacity: 0, x: 24 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        >
          <h3 className="impact-panelTitle">What we refuse to promise</h3>
          <ul className="impact-list">
            <li>Guaranteed #1 rankings, fixed CPA, or “instant” viral results</li>
            <li>Misleading before/after metrics or fake urgency on core offers</li>
            <li>Collecting data without a lawful basis in your privacy notice</li>
            <li>Impersonating platforms, celebrities, or other brands</li>
          </ul>
          <p className="impact-foot">
            Platform policies change. Keep ads, destinations, and data practices accurate—and review official network
            help centers alongside our work.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Banner;
